/* unplugin-vue-components disabled */import { render } from "./pbl_xsj.vue?vue&type=template&id=35b32bc0&scoped=true"
import script from "./pbl_xsj.vue?vue&type=script&lang=js"
export * from "./pbl_xsj.vue?vue&type=script&lang=js"

import "../../assets/pbl/css/index_xsj.css?vue&type=style&index=0&id=35b32bc0&scoped=true&lang=css&external"
import "./pbl_xsj.vue?vue&type=style&index=1&id=35b32bc0&scoped=true&lang=css"
import "./pbl_xsj.vue?vue&type=style&index=2&id=35b32bc0&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b32bc0"]])

export default __exports__